// extracted by mini-css-extract-plugin
export default {"card":"batchCard_card__ToEpp","cardHeader":"batchCard_cardHeader__qLSqF","tableHeader":"batchCard_tableHeader__A0B-D","tableDataRow":"batchCard_tableDataRow__wj5wC"};